export default __webpack_public_path__ + "static/bridge-d71bb20f2d360f0dd9eee4fc55c6e022.png";